<template>
  <v-toolbar
    :color="colorMode"
    dark
    fixed
    app
  >
    <v-toolbar-side-icon
      v-if="responsive"
      @click.stop="toggleDrawer"
    ></v-toolbar-side-icon>

    <v-toolbar-title>
      {{ title }}
    </v-toolbar-title>

    <v-spacer />

    <v-toolbar-items>
      <v-flex
        align-center
        layout
        py-2
      >
        <v-btn
          class="toolbar-items"
          to="/projects"
          icon
        >
          <v-icon color="tertiary">dashboard</v-icon>
        </v-btn>

        <v-btn
          class="toolbar-items"
          icon
          @click="showUserInfo"
        >
          <v-icon color="tertiary">person</v-icon>

          <User
            :dialog="dialogUser"
            :key="userKey"
          />
        </v-btn>

        <!-- FIXME: solucionar la apertura simultanea de los dos dialogs -->
        <!-- <v-btn
          class="toolbar-items"
          icon
          @click="showAboutInfo"
        >
          <v-icon color="tertiary">help</v-icon>

          <About
            :dialog="dialogAbout"
            :key="aboutKey"
          />
        </v-btn> -->

        <v-btn
          class="toolbar-items"
          icon
          @click="logout"
        >
          <v-icon color="tertiary">exit_to_app</v-icon>
        </v-btn>
      </v-flex>
    </v-toolbar-items>

    <v-dialog
      v-model="dialogMode"
      width="500"
      @keydown.enter="dialogMode = false"
    >
      <v-card>
        <v-toolbar
          :color="colorMode"
          dark
        >
          <v-toolbar-title>
            Aviso:  {{ msg }}
          </v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          {{ message }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="info"
            @click="dialogMode = false"
          >
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-toolbar>
</template>

<script>
import User from './TheUser'
// import About from './../views/About'

export default {
  name: 'Toolbar',
  components: {
    User
    // About
  },

  created () {
    this.route = this.$route

    let backConf = this.$store.state.appConf.back
    this.colorMode = backConf.color ? backConf.color : 'primary'
    this.dialogMode = backConf.dialog
    this.toolbarMsg = backConf.toolbarMsg
    this.message = backConf.message
  },

  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)

    this.dialogUser = false
    this.dialogAbout = false
  },

  data: function () {
    return {
      route: {
        name: 'Proyectos',
        path: '/projects'
      },

      view: null,
      responsive: false,

      colorMode: null,
      dialogMode: false,
      toolbarMsg: null,
      message: null,

      dialogUser: false,
      userKey: 0,

      dialogAbout: false,
      aboutKey: 0
    }
  },

  watch: {
    '$route' (val) {
      this.route = this.$route
    },

    '$store.state.actualProject': function () {
      this.project = this.$store.state.actualProject.nombre_proyecto
    },

    '$store.state.actualOperation': function () {
      this.operativo = this.$store.state.actualOperation.nombre_operativo
    },

    title () {
      this.dialogUser = false
      this.dialogAbout = false
    }
  },

  computed: {
    'title': function () {
      return this.toolbarMsg ? this.toolbarMsg + ': ' + this.route.name : this.route.name
    }
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },

  methods: {
    /** Funcion que cambia el estado del drawer
     */
    toggleDrawer () {
      let toggle = !this.$store.state.drawer
      this.$store.commit('toggle_drawer', toggle)
    },

    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
        this.responsiveInput = false
      } else {
        this.responsive = false
        this.responsiveInput = true
      }
    },

    /**
     * Carga el dialog con la información del usuario
     */
    showUserInfo: function () {
      this.dialogUser = true
      this.userKey += 1
    },

    /**
     * Carga el dialog con la información de la aplicación
     */
    showAboutInfo: function () {
      this.dialogAbout = true
      this.aboutKey += 1
    },

    /**
     * Sale de la aplicación
     */
    logout: function () {
      this.$store.dispatch('logout')
        .then(() => {
          this.$router.push('/')
        })
    }
  }
}
</script>
